import openErrorModal from "../../Error/ErrorModal";
import { validateOrder, createOrder, createPayment, checkOrderTagCode } from "../../HTTPRequests/OrderRequests";
import { openBackendValidationErrorModal } from "../../Error/ErrorUtilities";
import Loader from "../../DomUtilities/Loader";
import Mediator from "../../Utilities/Mediator";
import OrderResponse from "../../Models/Response/OrderResponse";
import OrderPrintHandler from "../OrderPrintHandler";
import OrderHandler from "./OrderHandler";
import CreatePayment from "../../Models/CreatePayment";
import DibsPaymentResponse from "../../Models/Response/DibsPaymentResponse";

export function createAnOrder(paymentId?: string, reload: boolean = true) {
	Loader.show();
	OrderHandler.order.paymentId = paymentId;
	createOrder(OrderHandler.order)
		.then((response: OrderResponse) => {
			window.onbeforeunload = null;
			if (response.htmlString) {
				new OrderPrintHandler(null, response.htmlString);
			}
			if (reload) {
				location.reload();
			}
		}, (error) => { //backend error
			Mediator.emit("orderCreationFailed");
			openBackendValidationErrorModal(error);
		}).catch(() => { //frontend error
			openErrorModal();
		}).finally(() => {
			Loader.hide();
		});
}

export function validateOrderAndCreatePayment(): void {
	Loader.show();
	validateOrder(OrderHandler.order)
		.then(() => {
			createAPayment();
		}, (error: { body: string, status: number }) => { //backend error
			Mediator.emit("orderCreationFailed");
			if (error.status == 409) {
				openErrorModal(error.body, null, null, null, "auto");
			} else {
				openBackendValidationErrorModal(error);
			}
		}).catch(() => { //frontend error
			openErrorModal();
		}).finally(() => {
			Loader.hide();
		});
}

function createAPayment() {
	Loader.show();
	const payment = new CreatePayment();
	payment.items = OrderHandler.order.items;
	createPayment(payment)
		.then((response: DibsPaymentResponse) => {
			Mediator.emit("orderPaymentCreated", response);
		}, () => { //backend error
			Mediator.emit("orderCreationFailed");
			openErrorModal();
		}).catch(() => { //frontend error
			openErrorModal();
		}).finally(() => {
			Loader.hide();
		});
}

export function validateTagCodeAndCreateOrder() {
	if (OrderHandler.order.tagCode) {
		Loader.show();
		checkOrderTagCode(OrderHandler.order.tagCode)
			.then(() => {
				createAnOrder();
			}, (error: { body: string, status: number }) => { //backend error
				Mediator.emit("orderCreationFailed");
				if (error.status == 409) {
					openErrorModal(error.body, null, null, null, "auto");
				} else {
					openErrorModal();
				}
			}).catch(() => { //frontend error
				openErrorModal();
			}).finally(() => {
				Loader.hide();
			});
	} else {
		createAnOrder();
	}
}
